"use strict";

exports.__esModule = true;
exports.WorkdayOffsetSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _luxon = require("luxon");
var _Core = require("../../Core");
var _timeDefinitions = require("../../timeDefinitions");
var _excluded = ["translator"];
var _class, _WorkdayOffsetSelector;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "WorkdayOffsetSelector__Container",
  componentId: "sc-1pq97ay-0"
})(["max-width:600px;"]);
var FlexRange = _styledComponents["default"].input.withConfig({
  displayName: "WorkdayOffsetSelector__FlexRange",
  componentId: "sc-1pq97ay-1"
})(["width:100%;"]);
var LabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "WorkdayOffsetSelector__LabelWrapper",
  componentId: "sc-1pq97ay-2"
})(["display:flex;align-items:center;"]);
var StartLabel = _styledComponents["default"].strong.withConfig({
  displayName: "WorkdayOffsetSelector__StartLabel",
  componentId: "sc-1pq97ay-3"
})(["flex:1;margin-right:auto;"]);
var EndLabel = _styledComponents["default"].strong.withConfig({
  displayName: "WorkdayOffsetSelector__EndLabel",
  componentId: "sc-1pq97ay-4"
})(["flex:1;margin-left:auto;text-align:right;"]);
var ValueLabel = _styledComponents["default"].strong.withConfig({
  displayName: "WorkdayOffsetSelector__ValueLabel",
  componentId: "sc-1pq97ay-5"
})(["flex:1;margin-left:auto;margin-right:auto;text-align:center;display:flex;flex-direction:column;span{font-size:2rem;}small{font-size:1.2rem;}"]);
var OffsetTime = function OffsetTime(_ref) {
  var value = _ref.value;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var time = _luxon.DateTime.local().startOf("day").plus({
    milliseconds: value
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, time.toLocaleString(_luxon.DateTime.TIME_SIMPLE)), value < 0 && /*#__PURE__*/_react["default"].createElement("small", null, translate("WorkdayOffsetSelector.OffsetTime.previousDay", "(previous day)")));
};
var WorkdayOffsetSelector = exports.WorkdayOffsetSelector = (0, _Core.withTranslator)(_class = (_WorkdayOffsetSelector = /*#__PURE__*/function (_Component) {
  function WorkdayOffsetSelector() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      value: _this.props.value >= -(0, _timeDefinitions.getHoursMillis)(12) && _this.props.value <= (0, _timeDefinitions.getHoursMillis)(12) ? _this.props.value : 0
    };
    _this.handleChange = function (e) {
      // $FlowFixMe
      var value = Number(e.target.value);
      _this.setState({
        value: value
      });
    };
    _this.handleBlur = function () {
      if (_this.props.value !== _this.state.value) {
        _this.props.onChange(_this.state.value);
      }
    };
    return _this;
  }
  _inheritsLoose(WorkdayOffsetSelector, _Component);
  var _proto = WorkdayOffsetSelector.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      translate = _this$props.translator.translate,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(FlexRange, _extends({
      key: "range",
      step: 300000,
      min: -(0, _timeDefinitions.getHoursMillis)(12),
      max: (0, _timeDefinitions.getHoursMillis)(12)
    }, extra, {
      value: this.state.value,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      type: "range",
      "data-testid": "WorkdayOffsetSelector.range"
    })), /*#__PURE__*/_react["default"].createElement(LabelWrapper, {
      key: "LabelWrapper"
    }, /*#__PURE__*/_react["default"].createElement(StartLabel, null, translate("WorkdayOffsetSelector.startLabel", "Noon (Previous day)")), /*#__PURE__*/_react["default"].createElement(ValueLabel, null, this.state.value === 0 ? /*#__PURE__*/_react["default"].createElement("span", null, translate("WorkdayOffsetSelector.midnight", "Midnight")) : /*#__PURE__*/_react["default"].createElement(OffsetTime, {
      value: this.state.value
    })), /*#__PURE__*/_react["default"].createElement(EndLabel, null, translate("WorkdayOffsetSelector.endLabel", "Noon (Next day)"))));
  };
  return WorkdayOffsetSelector;
}(_react.Component), _WorkdayOffsetSelector.defaultProps = {
  translator: undefined
}, _WorkdayOffsetSelector)) || _class;